var $ = jQuery;

$(function(){
  if( $(".sylmeria-slider .slideshow").length ){
		var settings =  { 
							dots: true, 
							infinite: true,
							arrows: false,
							//prevArrow: $(".arrow.prev"),
							//nextArrow: $(".arrow.next"),
							slidesToShow: 1,
							slidesToScroll: 1,
							//fade: true,
							speed: 500,
							pauseOnHover:false
							/*autoplay: true,
							autoplaySpeed: 5000,*/
						};
						
		$(".sylmeria-slider .slideshow").slick( settings );
  }  

  if( $(".sylmeria-featured-items-slider:not(.collection-slider)").length ){
		var settings =  { 
							dots: true, 
							infinite: true,
							arrows: false,
							slidesToShow: 3,
							slidesToScroll: 3,
							speed: 500,
                            responsive: [
                                          {
                                            breakpoint: 749,
                                            settings: {
                                              slidesToShow: 1,
                                              slidesToScroll: 1,                                              
                                            }
                                          }
                                        ]
						};
						
		$(".sylmeria-featured-items-slider:not(.collection-slider) > .inner").slick( settings );
  }

  
  if( $(".sylmeria-featured-items-slider.collection-slider").length ){
		var settings =  { 
							dots: true, 
							infinite: true,
							arrows: false,
							slidesToShow: 3,
							slidesToScroll: 3,
							speed: 500,
                            responsive: [
                                          {
                                            breakpoint: 749,
                                            settings: {
                                              rows: 1,
                                              slidesToShow: 1,
                                              slidesToScroll: 1,                                              
                                            }
                                          }
                                        ]
						};

        var total_cards = $(".sylmeria-featured-items-slider.collection-slider > .inner .card-wrapper").length;
		if( total_cards > 9 ) settings.rows = 4;
        else if( total_cards > 6 ) settings.rows = 3;
        else if( total_cards > 3 ) settings.rows = 2;
        else settings.rows = 1;
    
		$(".sylmeria-featured-items-slider.collection-slider > .inner").slick( settings );
  }

  if( $(".footer-block.grid__item.footer-block--menu").length ){
    $(".footer-block.grid__item.footer-block--menu > .footer-block__heading").click( toggle_footer_accordion_menu );
  }

  if( $("#Details-HeaderMenu-1").length ){
    $("#Details-HeaderMenu-1").mouseenter(function(){
      $("#Details-HeaderMenu-1").attr("open","");
    });
    
    $("#Details-HeaderMenu-1").mouseleave(function(){
      $("#Details-HeaderMenu-1").removeAttr("open");
    });
  }
  /*
  if( $(".quantity__input").length ){
    $("body").on("change",".quantity__input", function(){
      console.log("AAAA");
      console.log( $(this).val() );
    });    
  }
  */
});

function toggle_footer_accordion_menu( e ){
  var $this = $(this);
  var window_width = $(window).width();
  
  if( window_width <= 766 ){    
    $this.parent().find(".footer-block__details-content").slideToggle();
  }
  else{
    return false;
  }
}